module.exports = __webpack_public_path__ + "static/media/Data_DESIGN_THINKING (1).23631377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/designThings/Data_DESIGN_THINKING (1).png
// module id = 245
// module chunks = 0